
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/pass",
      function () {
        return require("private-next-pages/[locale]/pass/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/pass"])
      });
    }
  